export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");
export const place = (g) => [g?.city, g?.country].filter(Boolean).join(", ") || "—";
export const usd = (n, d = 4) => (n == null ? "—" : `$${Number(n).toFixed(d)}`);
